const REDIRECT_LOADER_ID = 'cop-redirect-loader'

export const showRedirectLoader = (): void => {
    if (document.getElementById(REDIRECT_LOADER_ID)) return
    if (!document.getElementById(`${REDIRECT_LOADER_ID}-style`)) {
        const style = document.createElement('style')
        style.id = `${REDIRECT_LOADER_ID}-style`
        style.textContent = '@keyframes cop-redirect-spin{to{transform:rotate(360deg)}}'
        document.head?.appendChild(style)
    }
    const overlay = document.createElement('div')
    overlay.id = REDIRECT_LOADER_ID
    overlay.style.cssText = 'position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.9)'
    const spinner = document.createElement('div')
    spinner.style.cssText = 'width:50px;height:50px;border:4px solid #f3f3f3;border-top-color:#e60028;border-radius:50%;animation:cop-redirect-spin 1s linear infinite'
    overlay.appendChild(spinner)
    document.body?.appendChild(overlay)
}

export const hideRedirectLoader = (): void => {
    document.getElementById(REDIRECT_LOADER_ID)?.remove()
}